// @ts-nocheck
export default {
    SET_STORE_MANAGEMENT_GOODS_PRICE_SURCHARGE_INFOS_DIALOG_OPEN(state, isOpen) {
        state.isStoreManagementGoodsPriceSurchargeInfosDialogOpen = isOpen;
    },
    SET_STORE_MANAGEMENT_GOODS_PRICE_SURCHARGE_INFOS_ADD_SURCHARGE_SECTION_OPEN(state, isOpen) {
        state.isStoreManagementGoodsPriceSurchargeInfosAddSurchargeSectionOpen = isOpen;
    },
    SET_SELECTED_STORE_ID(state, storeId) {
        state.selectedStoreId = storeId;
    },
    SET_EDIT_SURCHARGE_ITEM(state, item) {
        state.editSurchargeItem = item;
    },
    POST_STORE_MANAGEMENT_GOODS_PRICE_SURCHARGE_INFOS: (state, data) => {
        state.storeManagementGoodsPriceSurchargeInfosList = data;
    },
    GET_STORE_MANAGEMENT_GOODS_PRICE_SURCHARGE_INFOS: (state, data) => {
        state.storeManagementGoodsPriceSurchargeInfosList = data;
    },
    PUT_STORE_MANAGEMENT_GOODS_PRICE_SURCHARGE_INFOS: (state, data) => {
        const index = state.storeManagementGoodsPriceSurchargeInfosList.findIndex((surcharge) => surcharge.id === data.id);
        state.storeManagementGoodsPriceSurchargeInfosList[index] = data;
    },
    DELETE_STORE_MANAGEMENT_GOODS_PRICE_SURCHARGE_INFOS: (state, data) => {
        state.storeManagementGoodsPriceSurchargeInfosList = data;
    },
    PUBLISH_GOODS_PRICE_SURCHARGE_INFOS_HAS_BEEN_CHANGED: () => {
        // subscribe mutation only
    },
    CLEAR_STORE_MANAGEMENT_GOODS_PRICE_SURCHARGE_INFOS: (state) => {
        state.storeManagementGoodsPriceSurchargeInfosList = [];
    },
};
